<template>
  <div class="form" id="form" ref="form">
    <form
      @submit.prevent="validate('form-1')"
      data-vv-scope="form-1"
      v-show="this.authType === 'login'"
    >
      <div class="input-wrapper">
        <vs-input
          v-validate="'required|email'"
          :class="{'input': true, 'is-danger': errors.has('form-1.email') }"
          vs-size="large"
          type="text"
          name="email"
          class="inputx lower-input"
          :label="$t('auth.email_placeholder')"
          v-model="form.email"
          data-qa="auth-email"
        />
        <i v-show="errors.has('form-1.email')" class="fa fa-warning"></i>
        <span
          v-show="errors.has('form-1.email')"
          class="help is-danger"
        >{{ errors.first('form-1.email') }}</span>
      </div>
      <div class="input-wrapper">
        <div style="position: relative;">
          <vs-input
            v-validate="'required'"
            :class="{'input': true, 'is-danger': errors.has('form-1.password') }"
            vs-size="large"
            :type="showPass ? 'text' : 'password'"
            name="password"
            class="inputx"
            :label="$t('auth.password_placeholder')"
            v-model="form.password"
            data-qa="auth-password"
          />
          <vs-button class="btn-eye" type="fill" 
            @click="showPass = !showPass"
            :icon="showPass ? 'visibility_off' : 'visibility'"
          ></vs-button>
        </div>
        <i v-show="errors.has('form-1.password')" class="fa fa-warning"></i>
        <span
          v-show="errors.has('form-1.password')"
          class="help is-danger"
        >{{ errors.first('form-1.password') }}</span>
        <div class="forgot-link">
          <p>
            {{$t('auth.forgot')}}
            <a
              class="underline"
              @click.prevent="forgot('form-1.email')"
            >{{$t('auth.link')}}</a>
          </p>
        </div>
      </div>
      <div class="input-wrapper">
        <vs-button vs-type="filled" color="#2F1937" type="submit" button="submit" data-qa="auth-submit">{{$t('auth.login.button')}}</vs-button>
      </div>
    </form>

    <form
      @submit.prevent="validate('form-2')"
      data-vv-scope="form-2"
      v-show="this.authType === 'signup' || this.authType === 'partner'"
    >
      <div class="input-wrapper">
        <vs-input
          v-validate="'required'"
          :class="{'input': true, 'is-danger': errors.has('form-2.firstname') }"
          vs-size="large"
          type="text"
          name="firstname"
          class="inputx"
          :label="$t('auth.firstname')"
          v-model="form.firstname"
        />
        <i v-show="errors.has('form-2.firstname')" class="fa fa-warning"></i>
        <span
          v-show="errors.has('form-2.firstname')"
          class="help is-danger"
        >{{ errors.first('form-2.firstname') }}</span>
      </div>
      <div class="input-wrapper">
        <vs-input
          v-validate="'required'"
          :class="{'input': true, 'is-danger': errors.has('form-2.lastname') }"
          vs-size="large"
          type="text"
          name="lastname"
          class="inputx"
          :label="$t('auth.lastname')"
          v-model="form.lastname"
        />
        <i v-show="errors.has('form-2.lastname')" class="fa fa-warning"></i>
        <span
          v-show="errors.has('form-2.lastname')"
          class="help is-danger"
        >{{ errors.first('form-2.lastname') }}</span>
      </div>
      <div class="input-wrapper">
        <vs-input
          v-validate="'required|phone'"
          :class="{'input': true, 'is-danger': errors.has('form-2.phone') }"
          vs-size="large"
          type="text"
          name="phone"
          class="inputx"
          :label="$t('auth.phone')"
          v-model="form.phone"
        />
        <i v-show="errors.has('form-2.phone')" class="fa fa-warning"></i>
        <span
          v-show="errors.has('form-2.phone')"
          class="help is-danger"
        >{{ errors.first('form-2.phone') }}</span>
      </div>
      <div class="input-wrapper">
        <vs-input
          v-validate="'required|email'"
          :class="{'input': true, 'is-danger': errors.has('form-2.email') }"
          vs-size="large"
          type="text"
          name="email"
          class="inputx lower-input"
          :label="$t('auth.email_placeholder')"
          v-model="form.email"
        />
        <i v-show="errors.has('form-2.email')" class="fa fa-warning"></i>
        <span
          v-show="errors.has('form-2.email')"
          class="help is-danger"
        >{{ errors.first('form-2.email') }}</span>
      </div>
      <div class="input-wrapper">
        <div style="position: relative;">
          <vs-input
            v-validate="'required'"
            :class="{'input': true, 'is-danger': errors.has('form-2.password') }"
            vs-size="large"
            :type="showPass ? 'text' : 'password'"
            name="password"
            class="inputx"
            :label="$t('auth.password_placeholder')"
            v-model="form.password"
            autocomplete="off"
          />
          <vs-button class="btn-eye" type="fill" 
            @click="showPass = !showPass"
            :icon="showPass ? 'visibility_off' : 'visibility'"
          ></vs-button>
        </div>
        <i v-show="errors.has('form-2.password')" class="fa fa-warning"></i>
        <span
          v-show="errors.has('form-2.password')"
          class="help is-danger"
        >{{ errors.first('form-2.password') }}</span>
      </div>
      <div class="input-wrapper">
        <vs-input
          :class="{'input': true }"
          vs-size="large"
          type="text"
          name="promo"
          class="inputx lower-input"
          :label="$t('auth.promo_placeholder')"
          v-model="form.promo"
        />
        <i v-show="errors.has('form-2.email')" class="fa fa-warning"></i>
        <span
          v-show="errors.has('form-2.email')"
          class="help is-danger"
        >{{ errors.first('form-2.email') }}</span>
      </div>
      <div class="input-wrapper checkbox-wrapper" v-if="this.authType === 'signup' || this.authType === 'partner'">
        <label for="terms">
          {{$t('auth.terms')}}
          <a class="underline" href="https://www.mashup-web.com/mentions-legales-cgs">{{$t('auth.termslink')}}</a>
        </label>
        <div class="checkbox">
          <div class="custom-checkbox">
            <input
              name="terms"
              id="terms"
              v-validate="'required'"
              :class="{'input': true, 'is-danger': errors.has('form-2.terms') }"
              type="checkbox"
              v-model="form.terms"
            >
            <span class="checkmark">
              <span>check</span>
            </span>
          </div>
        </div>
        <i v-show="errors.has('form-2.terms')" class="fa fa-warning"></i>
        <span
          v-show="errors.has('form-2.terms')"
          class="help is-danger"
        >{{ errors.first('form-2.terms') }}</span>
      </div>
      <div class="input-wrapper checkbox-wrapper" v-if="this.authType === 'signup'">
        <label for="trial">
          {{$t(form.promo && form.promo.length ? 'auth.trial.promo' : 'auth.trial')}}
        </label>
        <div class="checkbox">
          <div class="custom-checkbox">
            <input
              name="trial"
              id="trial"
              :class="{'input': true, 'is-danger': errors.has('form-2.trial') }"
              type="checkbox"
              v-model="form.trial"
            >
            <span class="checkmark">
              <span>check</span>
            </span>
          </div>
        </div>
      </div>
      <!--<div class="input-hidden partner" v-if="this.authType === 'partner'">
        <input
          name="partner"
          id="partner"
          type="hidden"
          value="true"
          v-model="form.partner"
        >
      </div>-->
      <div class="input-wrapper">
        <vs-button vs-type="filled" color="#2F1937" type="submit" button="submit">{{$t('auth.signup.button')}}</vs-button>
      </div>
    </form>
  </div>
</template>

<script>

const phoneValidate = {
  getMessage(field, args) {
    return `The phone must be a valid phone number`;
    //return this.$t(`auth.form.error.phone`)
  },
  validate(value, args) {
    // Custom regex for a phone number 
    // eslint-disable-next-line
    const MOBILEREG = /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/
    // Check for either of these to return true
    return MOBILEREG.test(value);
  }
};

const emailValidate = {
  getMessage(field, args) {
    return `The mail must be a valid mail adress`;
  },
  validate(value, args) {
    // Custom regex for a phone number 
    // eslint-disable-next-line
    const MAILREG = /^[\w-\.\+]+@([\w-]+\.)+[\w-]{2,10}$/
    // Check for either of these to return true
    return MAILREG.test(value.trim());
  }
};

export default {
  name: 'component-form',

  data() {
    return {
      form: {
        firstname: null,
        lastname: null,
        email: null,
        password: null,
        trial: true,
        phone: null,
        promo: null
      },
      terms: false,
      page: null,

      showPass: false
    }
  },

  props: {
    authType: {
      type: String,
      required: true
    }
  },

  watch: {
    "form.phone": function(){
      this.form.phone = this.form.phone.replaceAll(" ", "").replaceAll(/[^0-9.\-()+s]+/g, "")
    }
  },

  beforeMount(){
    this.$validator.extend('phone', phoneValidate);
    this.$validator.extend('email', emailValidate);
  },

  methods: {    
    /**
     * Check form data before submit
     * @param {Object} scope - Form scope to check
     */
    validate(scope) {
      this.$validator.validateAll(scope).then(result => {
        if (!result && this.$validator.errors.items.length) return
        this.submit()
      })
    },

    /**
     * Emit submit event to parent
     * @private
     */
    submit() {
      this.$emit('submit-clicked', this.form)
    },

    /**
     * Check email before emit forgot password event to parent
     * @param {Object} name - Field name to check
     */
    forgot(name) {
      this.$validator.validate(name).then(result => {
        if (!result && this.$validator.errors.items.length) return
        this.$emit('forgot-clicked', this.form.email)
      })
    }
  }
}
</script>
